(() => {
  'use strict';

  const config = window.MAHAnalytics || {};
  if (config.enabled === false) return;

  const cleanText = (value) => String(value || '').replace(/\s+/g, ' ').trim().slice(0, 160);
  const publish = (eventName, data = {}) => {
    const payload = {
      ...data,
      page_path: window.location.pathname,
      page_title: document.title,
      launch_stage: config.launchStage || 'prelaunch'
    };

    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(eventName, payload);
      }
      if (config.debug && window.console) console.info('[MAH analytics]', eventName, payload);
    } catch (error) {
      if (config.debug && window.console) console.warn('[MAH analytics error]', error);
    }
  };

  const serviceHandles = new Set([
    'services',
    'autism-therapy-services',
    'gut-microbiome-testing',
    'product-guidance',
    'clinical-programmes',
    'regenerative-therapy-autism',
    'distributor-enquiries'
  ]);

  document.addEventListener('click', (event) => {
    const element = event.target.closest('a, button');
    if (!element) return;

    const explicit = element.dataset.mahTrack;
    const text = cleanText(element.textContent || element.getAttribute('aria-label'));
    const href = element.tagName === 'A' ? element.getAttribute('href') || '' : '';
    let url;
    try { url = href ? new URL(href, window.location.origin) : null; } catch (_) { url = null; }

    if (explicit) {
      publish(`mah_${explicit}`, {
        link_text: text,
        link_url: url ? url.href : href,
        provider: element.dataset.mahProvider || undefined
      });
      return;
    }

    if (url && (url.hostname === 'wa.me' || url.hostname.endsWith('whatsapp.com'))) {
      publish('mah_whatsapp_click', { link_text: text, link_url: url.href });
      return;
    }

    if (url && ['www.stemcells.center', 'stemcells.center', 'www.vitaguidingstars.com', 'vitaguidingstars.com'].includes(url.hostname)) {
      publish('mah_provider_outbound', { link_text: text, link_url: url.href, provider_domain: url.hostname });
      return;
    }

    if (url && url.origin === window.location.origin && url.pathname.startsWith('/pages/')) {
      const handle = url.pathname.split('/').filter(Boolean).pop();
      if (serviceHandles.has(handle)) publish('mah_service_page_click', { link_text: text, page_handle: handle, link_url: url.href });
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (form.classList.contains('mah-footer-newsletter')) {
      publish('mah_newsletter_submit', { form_location: 'footer' });
    } else if ((form.getAttribute('action') || '').includes('/contact')) {
      publish('mah_contact_form_submit', { form_id: form.id || undefined });
    }
  });

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement || input instanceof HTMLSelectElement)) return;
    if (input.name === 'selling_plan' || input.closest('[data-selling-plan-group]')) {
      publish('mah_subscription_option_selected', {
        product_handle: document.body.className.match(/product-([^\s]+)/)?.[1],
        selection: cleanText(input.value)
      });
    }
  });

  if (document.body.classList.contains('template-article')) {
    let elapsed = false;
    let depth = false;
    let sent = false;
    const maybePublish = () => {
      if (!sent && elapsed && depth) {
        sent = true;
        publish('mah_article_engaged', { engagement_seconds: 30, scroll_threshold: 50 });
      }
    };
    window.setTimeout(() => { elapsed = true; maybePublish(); }, 30000);
    window.addEventListener('scroll', () => {
      const available = document.documentElement.scrollHeight - window.innerHeight;
      if (available > 0 && (window.scrollY / available) * 100 >= 50) {
        depth = true;
        maybePublish();
      }
    }, { passive: true });
  }
})();
